import React from "react";
import {
  Grid,
  TableBody,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";
import { readableFormatDate } from "shared/utils";

export const PromotionalDetails = ({data}) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={6}>
            Promotional Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Reason</TableBodyCell>
                <TableBodyCell className="common_table_content">{data['reason']}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                <TableBodyCell className="common_table_content">{data['comment']}</TableBodyCell>
              </TableBody>
            </table>
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                <TableBodyCell className="common_table_content">{readableFormatDate(data['created_at'])}</TableBodyCell>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
